import React from 'react';

import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

type ProductImageWrapperProps = BoxProps & {
  background?: string;
};

export const ProductImageWrapper = ({ background, style, ...props }: ProductImageWrapperProps) => (
  <Box
    {...props}
    style={[styles.productImageWrapper, background && { backgroundColor: background }, style]}
  />
);

export const StyledProductPicture = Picture.withConfig({
  width: '100%',
  alignSelf: 'center',
});

export const ProductInformationContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productInformationContainer, style]} />
);

const styles = StyleSheet.create({
  productImageWrapper: {
    backgroundColor: primitive.$white,
    flex: 1,
  },
  productInformationContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    paddingHorizontal: 16,
    width: '100%',
  },
});
